import { AlarmClock, ArrowRight } from "lucide-react";

export const DAY_HR = ["NED", "PON", "UTO", "SRI", "ČET", "PET", "SUB"];

export function toYmd(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function addDays(dateStr, n) {
  const d = new Date(`${dateStr}T00:00:00`);
  d.setDate(d.getDate() + n);
  return toYmd(d);
}

export function fmtShort(dateStr) {
  const d = new Date(`${dateStr}T00:00:00`);
  return `${DAY_HR[d.getDay()]} ${d.getDate()}.${d.getMonth() + 1}.`;
}

export function EarlyMorningBanner({ ride }) {
  if (!ride) return null;
  return (
    <div
      data-testid="early-morning-banner"
      className="mb-4 rounded-2xl border border-amber-500/40 bg-amber-500/10 p-4 flex items-start gap-3"
    >
      <div className="w-10 h-10 shrink-0 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center">
        <AlarmClock className="w-5 h-5 text-amber-400" />
      </div>
      <div className="min-w-0">
        <p className="text-sm text-amber-200 font-semibold">
          Podsjetnik: sutra imate ranojutarnji transfer u {ride.pickup_time}
        </p>
        <p className="text-xs text-amber-300/80 mt-1 flex items-center gap-1 flex-wrap">
          <span className="truncate max-w-[45%]">{ride.pickup_location}</span>
          <ArrowRight className="w-3 h-3 shrink-0" />
          <span className="truncate max-w-[45%]">{ride.dropoff_location || "—"}</span>
        </p>
        <p className="text-[11px] text-amber-400/60 mt-1">Ne zaboravite naviti budilicu.</p>
      </div>
    </div>
  );
}

export function WeekAgendaBar({ today, counts, selectedDate, onSelectDay }) {
  const base = new Date(`${today}T00:00:00`);
  const mondayOffset = (base.getDay() + 6) % 7;
  const days = Array.from({ length: 7 }, (_, i) => addDays(today, i - mondayOffset));
  return (
    <div data-testid="week-agenda-bar" className="mb-4 rounded-2xl border border-white/10 bg-[#0d0d0d] p-2">
      <div className="grid grid-cols-7 gap-1">
        {days.map((d) => {
          const dd = new Date(`${d}T00:00:00`);
          const isToday = d === today;
          const isPast = d < today;
          const selected = selectedDate === d;
          const count = counts[d] || 0;
          return (
            <button
              key={d}
              disabled={isPast}
              onClick={() => onSelectDay(d)}
              data-testid={`agenda-day-${d}`}
              className={`relative rounded-xl py-2 flex flex-col items-center gap-0.5 transition-colors
                ${selected ? "bg-[#C5A059] text-black" : isPast ? "opacity-30" : "hover:bg-white/5"}
                ${isToday && !selected ? "border border-[#C5A059]/50" : "border border-transparent"}`}
            >
              <span className={`text-[9px] uppercase tracking-[0.15em] ${selected ? "text-black/70" : "text-zinc-500"}`}>
                {DAY_HR[dd.getDay()]}
              </span>
              <span className={`text-sm font-medium ${selected ? "text-black" : "text-zinc-200"}`}>
                {dd.getDate()}
              </span>
              {count > 0 ? (
                <span
                  data-testid={`agenda-count-${d}`}
                  className={`min-w-[16px] h-4 px-1 rounded-full text-[9px] font-bold flex items-center justify-center
                    ${selected ? "bg-black/80 text-[#C5A059]" : "bg-[#C5A059] text-black"}`}
                >
                  {count}
                </span>
              ) : (
                <span className="h-4" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function ScheduleTabs({ filter, onChange }) {
  const tabs = [
    { key: "today", label: "Danas" },
    { key: "tomorrow", label: "Sutra" },
    { key: "week", label: "7 dana" },
  ];
  return (
    <div data-testid="schedule-tabs" className="mb-4 grid grid-cols-3 gap-2">
      {tabs.map((t) => {
        const active = filter.type === t.key;
        return (
          <button
            key={t.key}
            onClick={() => onChange({ type: t.key })}
            data-testid={`schedule-tab-${t.key}`}
            className={`h-10 rounded-full text-xs uppercase tracking-[0.15em] font-semibold border transition-colors
              ${active
                ? "bg-[#C5A059] text-black border-[#C5A059]"
                : "bg-white/5 text-zinc-400 border-white/10 hover:bg-white/10 hover:text-zinc-200"}`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
